import { ExperienceName, type ExperienceNameType } from './constants';

export const REMIX_EXPERIENCES: readonly ExperienceNameType[] = [
	ExperienceName.REMIX_START,
	ExperienceName.REMIX_AIFC_HANDOFF,
	ExperienceName.REMIX_RENDERS_IN_MODAL,
	ExperienceName.REMIX_CREATE,
	ExperienceName.REMIX_OPEN_MENU,
	ExperienceName.REMIX_REGENERATE,
	ExperienceName.REMIX_INSERT,
	ExperienceName.REMIX_PASTE,
	ExperienceName.REMIX_COPY_FROM_PREVIEW,
	ExperienceName.REMIX_DIAGRAM_PASTE_FINALIZE,
	ExperienceName.REMIX_DUPLICATE_APP,
];
